<div class="Error404">
  <h2>Page Not Found</h2>
  <button class="Button404" (click)="BackToHome()"> Back To Home</button>
</div>

